const DEFAULT_DURATION_MS = 45000;
let appAuthLoadingUntil = 0;

const getNativeLoadingPlugin = () => {
  try {
    const capacitor = (window as any)?.Capacitor;
    if (!capacitor) return null;
    const isNative =
      typeof capacitor.isNativePlatform === 'function'
        ? capacitor.isNativePlatform()
        : !!capacitor.Plugins;
    if (!isNative) return null;
    return capacitor.Plugins?.Loading || null;
  } catch {
    return null;
  }
};

const startNativeLoading = (
  title = 'Signing in...',
  maxVisibleMs = DEFAULT_DURATION_MS
) => {
  const request = getNativeLoadingPlugin()?.start?.({ title, maxVisibleMs });
  if (request?.catch) request.catch(() => {});
};

const endNativeLoading = () => {
  const request = getNativeLoadingPlugin()?.end?.({});
  if (request?.catch) request.catch(() => {});
};

export const markAppAuthLoading = (
  durationMs = DEFAULT_DURATION_MS,
  options: { native?: boolean; title?: string } = {}
) => {
  if (typeof window === 'undefined') return;
  try {
    appAuthLoadingUntil = Date.now() + durationMs;
    if (options.native) {
      startNativeLoading(options.title, durationMs);
    }
  } catch {
    // ignore storage exceptions
  }
};

export const clearAppAuthLoading = () => {
  if (typeof window === 'undefined') return;
  try {
    appAuthLoadingUntil = 0;
    endNativeLoading();
  } catch {
    // ignore storage exceptions
  }
};

export const isAppAuthLoadingActive = () => {
  if (typeof window === 'undefined') return false;
  return Date.now() < appAuthLoadingUntil;
};
